/* global window, document */
import React from 'react'
import PropTypes from 'prop-types'
import bem from '@argos/utils/esnext/bem'
import debounce from '@argos/utils/esnext/debounce'
import SmoothScroll from '@argos/utils/esnext/smooth-scroll'
import ArrowIcon from '@argos/icons/esnext/Arrow/Arrow'

import './back-to-top.scss'

const cn = bem({ prefix: 'ac-', block: 'back-to-top' })

function scrollToTop() {
  SmoothScroll.scrollHere(document.body, 0, 300)
}

class BackToTop extends React.Component {
  static propTypes = {
    triggerOffset: PropTypes.number,
  }

  static defaultProps = {
    triggerOffset: 600,
  }

  constructor(props) {
    super(props)
    this.state = { visible: false }
    this.handleScroll = debounce(this.handleScroll, 50)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    if (window.pageYOffset > this.props.triggerOffset && !this.state.visible) {
      this.setState({ visible: true })
    } else if (window.pageYOffset < this.props.triggerOffset && this.state.visible) {
      this.setState({ visible: false })
    }
  }

  render() {
    return (
      <div id='back-to-top' className={cn(null, { visible: this.state.visible })} onClick={scrollToTop} tabIndex='0'>
        <ArrowIcon className={cn('chevron')} height='13' width='20' dir='up' />
      </div>
    )
  }
}

export default BackToTop
